import { j as n } from "./atoms-v218.js";
import { forwardRef as i, useRef as o, useImperativeHandle as D } from "react";
import { CalendarTableDataCell as R } from "./atoms-v21269.js";
import { TableDataRow as T } from "./atoms-v21270.js";
function b({ colorTheme: s = "light", isLoading: p, month: m, weekRowConfig: e, weekRowConfigIdx: c }, u) {
  const a = o(null), t = o({});
  return D(
    u,
    () => ({
      get calendarDataCellAPIMap() {
        return t.current;
      },
      get ref() {
        return a.current;
      }
    })
  ), /* @__PURE__ */ n.jsx(T, { "aria-label": "Calendar Data Row", ref: a, children: e.dates.map((l, r) => /* @__PURE__ */ n.jsx(
    R,
    {
      colorTheme: s,
      dateConfig: l,
      dateConfigIdx: r,
      isFirstOfType: r === 0,
      isLastOfType: r === e.dates.length - 1,
      isLoading: p,
      month: m,
      ref: (f) => t.current[l.cellUID] = f
    },
    r
  )) }, c);
}
const x = i(b);
export {
  x as CalendarTableRow,
  b as ComponentToForward
};
